export enum CarStatus {
    Available = 'Available', Sold = 'Sold'
}